// Brand logos: Simple Icons CDN for Airbnb, Booking, Tripadvisor; custom Vrbo wordmark.

const BrandImg = ({ slug, color, alt, className }) => (
  <img
    src={`https://cdn.simpleicons.org/${slug}/${color}`}
    alt={alt}
    className={className || "h-9 w-auto"}
    loading="lazy"
  />
);

export const AirbnbLogo = ({ className }) => (
  <BrandImg slug="airbnb" color="FF385C" alt="Airbnb" className={className} />
);

export const BookingLogo = ({ className }) => (
  <BrandImg slug="bookingdotcom" color="003B95" alt="Booking.com" className={className} />
);

export const TripadvisorLogo = ({ className }) => (
  <BrandImg slug="tripadvisor" color="34E0A1" alt="Tripadvisor" className={className} />
);

// Custom inline Vrbo wordmark (Simple Icons does not host Vrbo)
export const VrboLogo = ({ className = "h-9 w-auto" }) => (
  <svg
    viewBox="0 0 200 80"
    className={className}
    role="img"
    aria-label="Vrbo"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      x="100"
      y="58"
      textAnchor="middle"
      fontFamily="'Outfit', system-ui, sans-serif"
      fontWeight="800"
      fontSize="60"
      fill="#3D67FF"
      letterSpacing="-2"
    >
      vrbo
    </text>
  </svg>
);

// Optional Abritel (kept for backward compat)
export const AbritelLogo = ({ className = "h-9 w-auto" }) => (
  <svg viewBox="0 0 200 80" className={className} role="img" aria-label="Abritel" xmlns="http://www.w3.org/2000/svg">
    <text
      x="100"
      y="58"
      textAnchor="middle"
      fontFamily="'Outfit', system-ui, sans-serif"
      fontWeight="800"
      fontSize="48"
      fill="#0067DB"
      letterSpacing="-1.5"
    >
      Abritel
    </text>
  </svg>
);
